export const MenuItemCoursesText = 'Courses';
export const MenuItemAboutUsText = 'About us';
export const MenuItemBlogText = 'Blog';
export const MenuItemSignInText = 'Sign in';

export const MenuItemCoursesLink = '/courses';
export const MenuItemAboutUsLink = '/contact';
export const MenuItemBlogLink = '/blog';
export const MenuItemSignInLink = '/login';
